import PNavLink from "../../common/Navigation/PNavLink";
import { Trans as T } from 'react-i18next';

import './SettingsNavigation.scss';

const MAIN_SETTING_PAGES = {
  profile      : "Profile & Notifications",
  billing      : "Plan & Billing",
  organization : "Organization Settings"
}

export default function SettingsNavigation({ unsavedChanges, onSaveChanges, loading }) {

  const renderNavigation = () => (
    <div className="navigation-container">
      { Object.entries(MAIN_SETTING_PAGES).map(([page, text]) => (
        <PNavLink key={page} to={`/${page}`}><T>{ text }</T></PNavLink>
      ))}
    </div>
  );

  const renderAlertBar = () => (
    <div className="alert-bar">
      <span><T>You have unsaved changes for this user</T></span>
      <button className="action" onClick={onSaveChanges} disabled={loading}><T>Save Changes</T></button>
    </div>
  );

  return (
    <div className="__settings-navigation">
      { unsavedChanges
      ? renderAlertBar()
      : renderNavigation()
      }
    </div>
  );
}
